import axios from 'axios'
import { getCookies, createTransactionID, useUtcTime } from '../Utils'
import { auditErrorRequest } from '../functions/auditErrorRequest'

const win: any = window

let config = {
  api: {
    baseURL: '',
    headers: {
      'Content-Type': 'application/json',
      Authorization: '',
      'x-api-key': '',
      'X-Correlation-Id': '',
      'X-Source-Channel': 'PORTAL',
      'X-Transaction-Id': '',
    },
  },
}

export const api = axios.create({ ...config.api })

api.interceptors.request.use(
  async (conf: any) => {
    const journeyName = getCookies('device-journeyName');
    const poid = getCookies('device-poid');

    conf.baseURL = win['apigee_bm_base_url']
    if (!conf.headers?.Authorization) {
      conf.headers.Authorization = `Bearer ${win['bmToken']}`;
    }
    conf.headers['x-api-key'] = win['apigee_bm_x_api_key']
    conf.headers['X-Transaction-Id'] = createTransactionID()
    conf.headers['X-Correlation-Id'] = win['x-co-id']
    conf.headers['JourneyName'] = journeyName
    conf.headers['X-Journey-Name'] = journeyName
    conf.headers['POID'] = poid;
    conf.headers['X-Timestamp'] = useUtcTime();
    return conf
  },
  (err: any) => {
    console.log('error in getting ', err)
  }
)

api.interceptors.response.use(
  async (response: any) => {
    return response;
  },
  async (error: any) => {
    if (error?.response) {
      return error?.response;
    } else {
      return error
    }
  }
);

const graphqlApi = (productId: any) => {
  const query = `{
    getProductOfferByID(id: "`+ productId + `") {
      id{
        key
        version
    }
    name
    externalID
    createdBy
    createdOn
    stock {
      storeStatus
      warehouseStatus
    }
    productSpecification{
        id
        name
    }
    specCharValueUse{
      name
      specCharacteristicValue{
        value
        isDefault
      }     
    }  
  category {
      id
      name
      type
      parentId
      isAnchor
      isOfferContainer
      parentHierarchy {
        id
        name
        parentId
        isAnchor
        isOfferContainer
      }
    }
    productOfferingPrice{
      id
      code
      name
      externalID
      processContext{
        id
        name
      }
      priceType
      price{
        unit
        value
      }
    }
      offerLabels{
        name
        description
        channel
      }
    }
  }`

  return api.post('/catalog-agg-query/graphql', { query: query });
  // return api.get('http://localhost:3002/graphQlAPI');
}

const createShoppingcart = (products: any, journeyName: string) => {
  const pc = products.productCharacteristic;
  const productCharacteristic = [];

  for (let i = 0; i < pc.length; i++) {
    const name = pc[i]?.name;
    const specCharacteristicValue = pc[i]?.specCharacteristicValue ?? [];
    if (name === "OfferingType") {
      const defaultVal = specCharacteristicValue.find(
        (val: { value: string; isDefault: boolean }) => val?.isDefault
      );
      if (defaultVal) {
        productCharacteristic.push({ name, value: defaultVal?.value ?? null });
      }
    } else {
      productCharacteristic.push({ name, value: specCharacteristicValue?.[0]?.value ?? null });
    }
  }

  const data = {
    "channel": {
      "id": "bo_lov_portals",
      "name": "Portals"
    },
    "place": {
      "id": "180497",
      "name": "Riyadh"
    },
    // "marketSegment": {
    //   "id": "bo_lov_marketsegment_b2c",
    //   "name": "B2C"
    // },
    "offerContainer": [
      {
        "additionalAttributes": [
          {
            "name": "orderType",
            "value": "Devices"
          }
        ],
        "cartItem": [
          {
            "action": "Add",
            "productOffering": {
              "id": products.productId,
              "name": "Product"
            },
            "product": {
              "productCharacteristic": productCharacteristic
            },
            "quantity": 1
          }
        ],
        "category": {
          "id": products.category.id,
          "name": products.category.name
        },
        "processContext": "ACQ"
      }
    ]
  }

  return api.post(`/shopping-cart/v3/shoppingCart?isNonPersistent=false`, data, {
    headers: {
      JourneyName: journeyName
    }
  });
  // return api.get('http://localhost:3001/createShoppingcart404Error');
}

const getAccountByNumber = (msisdn: any, journeyName: string, accessToken: any) => {

  //return api.get('http://localhost:3001/accountByMsisdn');

  return api.get(`/bmi-customer-management/services/customer?MSISDN=${msisdn}&JourneyName=${journeyName}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });
}

const subsidyEligibilityCheck = (req: any) => {

  const data: any = {
    msisdn: req.msisdn,
    productOfferId: req.packageId,
    sku: req.sku
  }
  // return api.get('http://localhost:3001/eligibilePromotions');
  return api.post(`/cem/bff-subsidy/v1/eligibilePromotions`, data);
}

const promotionQualification = (scData: any, promotionType: string) => {
  const data = {
    "channel": {
      "id": "bo_lov_portals",
      "name": "Portals"
    },
    "context": {
      "additionalAttributes": [
        {
          "name": "customerType",
          "value": promotionType
        }
      ],
      "shoppingCart": scData,
    }
  }

  return api.post(`/promotion-projection/v1/promotionQualification`, data);
}

const applyPromotion = (shoppingCartData: any, promotionData: any) => {
  const { ocId, scId } = shoppingCartData;
  const { promotionId, signature, actionObjectId, actionValue } = promotionData;

  const data = {
    "applyPromotionRequest": [
      {
        "id": ocId,
        "level": "offerContainer",
        "overrideAll": true,
        "promotions": [
          {
            "id": promotionId,
            "promotionAction": {
              "actionObjectId": actionObjectId,
              "actionValue": actionValue
            },
            "signature": signature
          }
        ]
      }
    ],
  }

  return api.post(`/shopping-cart/v3/shoppingCart/${scId}/applyPromotion?isNonPersistent=false`, data);
}

// const overrideSCInstallment = (scId: any, cartItemId: any, itemPriceId: any, ocId: any) => {
//   const data = {
//     priceOverride: {
//       actionType: "Discount %",
//       actionValue: "100",
//       cartItemId: cartItemId,
//       itemPriceId: itemPriceId,
//       offerContainerId: ocId
//     }
//   }

//   return api.post(`/shopping-cart/v3/shoppingCart/shoppingCart/${scId}/priceOverride`, data);
//   // return api.get('http://localhost:3001/applyInstallment');
// }

// const instalmentPatch = (req: any) => {
//   const { scId, ocId, instAmount, instMonths, PromotionTechnicalName, TotalDeviceInstallmentAmount } = req;
//   const data = {
//     context: {},
//     shoppingCartPatch: [
//       {
//         operation: "add",
//         path: `/offercontainer/${ocId}/additionalAttributes`,
//         value: [
//           {
//             name: "Commitment Period En",
//             value: `${instMonths} months`
//           },
//           {
//             name: "Commitment Period Ar",
//             value: "12 شهور"
//           },
//           {
//             name: "Installment Amount En",
//             value: `${instAmount} SAR`
//           },
//           {
//             name: "Installment Amount Ar",
//             value: "175 شهور"
//           },
//           {
//             name: "Promotion Technical Name",
//             value: PromotionTechnicalName
//           },
//           {
//             name: "TotalDeviceInstallmentAmount",
//             value: `${TotalDeviceInstallmentAmount} SAR`
//           }
//         ]
//       }
//     ]
//   }

//   return api.patch(`/shopping-cart/v3/shoppingCart/${scId}`, data);
//   // return api.get('http://localhost:3001/applyInstallment');
// }

const subsidyPatch = (scId: any, ocId: any, cartItemId: any,) => {
  const data = {
    context: {},
    shoppingCartPatch: [
      {
        operation: "patch",
        path: `/offercontainer/${ocId}/cartitem/${cartItemId}/product/productcharacteristic`,
        value: [
          {
            name: "OfferingType",
            value: "Subsidy"
          }
        ]
      }
    ]
  }
  return api.patch(`/shopping-cart/v3/shoppingCart/${scId}`, data);
  // return api.get('http://localhost:3001/subsidyPatch');
}

const removeAndCancelCart = (cartId: string) => {
  const data = {
    "context": {},
    "shoppingCartPatch": [
      {
        "operation": "patch",
        "path": "/status",
        "value": [
          {
            "status": "ABANDONED"
          }
        ]
      }
    ]
  }

  return api.patch(`/shopping-cart/v3/shoppingCart/${cartId}`, data);
}

const captureData = (shoppingCart: any, captureSection: any) => {
  let data: any = {
    context: {
      channel: shoppingCart.channel,
      serviceability: {},
      shoppingCart: shoppingCart
    },
    sections: captureSection
  }
  return api.post(`/checkout-api/v3/checkout/captureData`, data);
}

const updateAndValidateSC = (shoppingCartID: string) => {

  const data = {
    "ShoppingCartId": shoppingCartID
  }

  return api.post(`/mobily-shopping-cart-management/api/update-and-validate`, data);
}

const installmentPackageEligibility = (req: any) => {

  const data: any = {
    msisdn: req.msisdn,
    san: req.san,
    deviceTechnicalName: req.packageId,
    shoppingCartId: req.shoppingCartId,
    productOfferId: req.productOfferId
  }

  return api.post(`/cem/device-installment/package-eligibility/services`, data);
  // return api.get('http://localhost:3001/installmentPackageEligibility');
}

const installmentCustomerEligibility = (req: any) => {

  const data: any = {
    msisdn: req.msisdn,
    san: req.san,
    whitelistFlag: req.whitelistFlagVal,
    monthlyCommitmentAmt: req.monthlyAmount,
    shoppingCartId: req.shoppingCartId,
    productOfferId: req.productOfferId,
    installmentType: req.installmentType,
    promotionTechnicalName: req.promotionTechnicalName
  }

  return api.post(`/cem/device-installment/customer-eligibility/services`, data);
  //return api.get('http://localhost:3001/installmentCustomerEligibility');
}

const cemInitiateOTP = (msisdn: any, idNumber: any, lang: string) => {

  const data: any = {
    version: "v1",
    journey: "LOGIN",
    operation: "QUICK_LOGIN",
    language: lang,
    extraInfo: [
      {
        key: "ACCOUNT_NUMBER",
        value: msisdn
      },
      {
        key: "ACCOUNT_TYPE",
        value: "MSISDN"
      },
      {
        key: "ID_NUMBER",
        value: idNumber
      },
      {
        key: "LOGIN_TYPE",
        value: "QUICK"
      }
    ]
  }

  //return api.get('http://localhost:3001/cemOTPInitiate'); //success

  return api.post(`/cem/bff/login/v1/initiate`, data, {
    headers: {
      'cem-key': win["cem_key"]
    }
  });
}

const cemValidateOTP = (req: any) => {

  const data: any = {
    operation: "VALIDATE_LOGIN_BY_OTP",
    extraInfo: [
      {
        key: "REF_ID",
        value: req?.refId
      },
      {
        key: "OTP",
        value: req?.otp
      },
      {
        key: "IS_OAUTH_TOKEN",
        value: "N"
      },
      {
        key: "CLIENT_ID",
        value: req?.EnBmClientId
      },
      {
        key: "CLIENT_SECRET",
        value: req?.EnBmClientSecret
      }
    ]
  }

  //return api.get('http://localhost:3001/cemOtpValidate'); //success

  return api.post(`/cem/bff/login/v1/validate`, data, {
    headers: {
      'cem-key': win["cem_key"]
    }
  });
}

const cemResendOTP = (refId: any) => {

  const data: any = {
    operation: "RESEND_OTP",
    extraInfo: [
      {
        key: "REF_ID",
        value: refId
      }
    ]
  }

  return api.put(`/cem/bff/otp/v1/resend`, data, {
    headers: {
      'cem-key': win["cem_key"]
    }
  });

}

const callAuditService = (response: any, stepName: any) => {
  const data: any = auditErrorRequest(response, stepName)
  return api.post(`/api/mobily-audit-service/audit/save`, data);
}

const customerOfferEligibility = (msisdn: string) => {

  return api.get(`/cem/bff-subsidy/v1/deviceCustomerEligibility?msisdn=${msisdn}`);
  //  return api.get('http://localhost:3001/customerOffersEligibility');
}

const notifyMe = (req: any) => {
  const data: any = {
    email: req.email,
    msisdn: req.msisdn,
    poid: req.poid,
    sku: req.sku,
    lang: req.lang,
    otpReferenceId: req.otpReferenceId,
    notificationChannel: req.notificationChannel,
    extraInfo: req.extraInfo || [],
  };

  return api.post('/cem/stock-notification/v1/notifyMe', data);
  //  return api.get('http://localhost:3001/notifyMe'); // for local testing
};

const notifyMeOTPInitiate = (lang: any, encryptedACNumber: any, encryptedProductName: any) => {
  let data = {
    "version": "v1",
    "journey": "NOTIFY_ME",
    "operation": "SEND_OTP",
    "language": lang,
    "extraInfo": [
      {
        "key": "ACCOUNT_NUMBER",
        "value": encryptedACNumber
      },
      {
        "key": "PRODUCT_NAME",
        "value": encryptedProductName
      },
      {
        "key": "AUTOREAD_PRE",
        "value": ""
      },
      {
        "key": "AUTOREAD_POST",
        "value": ""
      }
    ]
  }
  return api.post(`/cem/bff/otp/v1/send`, data);
  //return api.get(`http://localhost:3001/notifyMeSend`);
}


const notifyMeOTPValidate = (otp: any, refId: any) => {
  const data = {
    "operation": "VALIDATE_OTP",
    "extraInfo": [
      {
        "key": "REF_ID",
        "value": refId
      },
      {
        "key": "OTP",
        "value": otp
      }
    ]
  }
  return api.put('/cem/bff/otp/v1/validate', data);
  // return api.get('http://localhost:3001/cemOtpValidate'); 
}

const applyInstallmentAPI = (req: any, accessToken: any) => {
  const { shoppingCartId, msisdn } = req;
  const data = {
    shoppingCartId: shoppingCartId,
    msisdn: msisdn
  }

  return api.post(`/cem/device-installment/v1/applyInstallment`, data,
    {
      headers: {
        'cem-key': win["cem_key"],
        Authorization: `Bearer ${accessToken}`
      }
    });

  //return api.get('http://localhost:3001/applyInstallment');
}

export {
  graphqlApi,
  createShoppingcart,
  getAccountByNumber,
  subsidyEligibilityCheck,
  promotionQualification,
  applyPromotion,
  removeAndCancelCart,
  captureData,
  updateAndValidateSC,
  installmentPackageEligibility,
  installmentCustomerEligibility,
  // overrideSCInstallment,
  // instalmentPatch,
  cemInitiateOTP,
  cemValidateOTP,
  cemResendOTP,
  subsidyPatch,
  callAuditService,
  customerOfferEligibility,
  notifyMe,
  notifyMeOTPInitiate,
  notifyMeOTPValidate,
  applyInstallmentAPI,
};
